import { render, staticRenderFns } from "./OrderFormStep6AgeTab.module.vue?vue&type=template&id=a2159924&scoped=true&"
import script from "./OrderFormStep6AgeTab.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep6AgeTab.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep6AgeTab.module.vue?vue&type=style&index=0&id=a2159924&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2159924",
  null
  
)

export default component.exports